export const popups = {
  registerRequest: {
    title: 'Kayıt başvurusu',
    description: 'Formu doldurun, sizinle iletişime geçelim.',
    button: 'Kayıt başvurusu gönder',
    form: {
      noteLabel: 'Bizi nasıl öğrendiniz?',
      notePlaceholder: 'Bizi nasıl öğrendiniz?',
      checkboxExperience: 'Kulüpte deneyimliyim',
      club: {
        nameLabel: 'Kulüp adı',
        namePlaceholder: 'Kulüp adı'
      }
    }
  },
  invite: {
    title: 'Yaşı doğrulayın',
    description:
      '18 yaşında mısınız? Platformu kullanmak için yaşınızı doğrulayın.',
    confirm: 'Evet, 18 yaşındayım'
  },
  deleteAccount: {
    title: 'Hesabı sil?',
    subTitle: 'Kaldırmayı iptal etmek imkansız olacaktır.',
    description:
      'Silmek yerine profilinizi gizleyebilirsiniz. Siz tekrar açana kadar sizden başka kimse göremez.'
  },
  exitFromProfile: {
    title: 'Çıkış yap?',
    description: 'Çıkış yapmak istediğinizi onaylayın.'
  },
  hideAccount: {
    title: 'Profili gizle?',
    description:
      'Profiliniz, yeniden açmaya karar verene kadar sizden başka kimseye görünmez.'
  },
  mainPhoto: {
    title: 'Kapak fotoğrafı',
    description: 'Özgeçmişiniz için bir kapak fotoğrafı seçin'
  },
  updateVideo: {
    title: 'Video yükleme',
    description: 'Lütfen videonun yüklenmesini bekleyin'
  },
  consumation: {
    title: 'Tüketim',
    description:
      'En popüler beş tüketim kalemini, fiyatlarını ve sanatçıya ödenen yüzdeyi girin.'
  },
  crazyMenu: {
    title: 'Çılgın menü',
    description: 'En popüler beş çılgın menü öğesini ve fiyatlarını girin.'
  },
  warningOnCloseOnboarding: {
    title: 'Emin misiniz?',
    description:
      'Ayrıntıları doldurmayı durdurmak istediğinizden emin misiniz? Özgeçmişiniz yayınlanmayacak. Kulüpler size en iyi tekliflerini gönderemeyecek. Daha sonra devam edebilirsiniz.'
  },
  foreignLanguage: {
    title: 'Yeterlilik seviyesi'
  },
  createWorkItem: {
    title: 'Davet onayı',
    titleRequest: 'Talep onayı',
    inviteDescription:
      'Bu bilgiler ön taslaktır. Sanatçı ile sohbette bunları görüşebilir ve daveti güncelleyebilirsiniz.',
    requestDescription:
      'Bu bilgiler ön taslaktır. Kulüple sohbette bunları görüşebilir ve talebi güncelleyebilirsiniz.',
    suggestVacancy: 'Sanatçı için bir pozisyon önerin',
    selectVacancy: 'İlgilendiğiniz pozisyonu belirtin',
    ticketCreditOption: 'Bilet kredisi seçeneği',
    ticketCreditRequired: 'Bilet kredisi gerekli mi?'
  },
  clubWorkInteraction: {
    artistWorkAtClub: 'Sanatçı kulübünüzde çalışıyor.',
    setLastDay: {
      title: 'Son çalışma günü ayarlansın mı?',
      setLastWorkDate: 'Sanatçının son çalışma gününü seçin',
      description:
        'Sanatçı için son tarih ayarlandıktan sonra değiştirilemez. Bu tarihten sonra sanatçı kulübünüzle olan sözleşmeyi tamamlayacaktır.'
    },
    artistArrival: {
      title: 'Sanatçının gelişi onaylansın mı?',
      description: 'Kulübünüzde sanatçının varlığını onaylıyorsunuz.',
      information:
        'İş, sanatçının işyerindeki varlığını onayladıktan sonra başlayacak.'
    },
    workCancel: {
      title: 'Sözleşme iptal edilsin mi?',
      description: 'Sözleşmenin iptalini onaylıyorsunuz'
    },
    wantEndDate: {
      title: 'Sanatçı son günü belirlemek istiyor.'
    },
    newEndDate: {
      title: 'Son çalışma günü'
    }
  },
  artistWorkInteraction: {
    manageCurentContract: {
      pendingLastWorkDateRequest:
        'Sözleşmenin tamamlanması talebiniz inceleniyor.',
      workStartOnArtistArrivalConfirm:
        'İş, kulübün işyerindeki varlığınızı onaylamasından sonra başlayacak.',
      weCanRequestLastWorkDate:
        'Kulüpten sözleşme bitiş tarihinizi talep edin.',
      clubSetLastWorkDate:
        'Kulüp bu kulüpteki son çalışma tarihinizi belirledi.'
    }
  },
  changeProfile: {
    title: 'Kulüplerim'
  },
  confirmOnboardingCompletion: {
    title: 'Portföyünüz yayınlandı',
    description: 'Artık kulüpler sizi çalışmaya davet edebilir.'
  },
  videoUploading: {
    title: 'Video yükleme',
    description: 'Lütfen videonun yüklenmesini bekleyin'
  },
  addWorkItem: {
    title: 'İş yeri',
    vacancyQuestion: 'Hangi pozisyonda çalıştınız?',
    validationMessage: 'Şu anda çalıştığınızı zaten belirttiniz.'
  },
  selectMainPhoto: {
    title: 'Ana fotoğraf',
    description: 'Özgeçmişiniz için bir kapak fotoğrafı seçin'
  },
  deleteWorkExperience: {
    title: 'Sil?',
    description: 'Bu iş deneyimini silmek istediğinizden emin misiniz?'
  }
};
